import "./Autosuggestion.scss";

import * as React from "react";
import { FormattedMessage } from "react-intl";
import { computeHighlighting, formatHighlighting } from "../../utils/AutosuggestUtil";
import { ArticleSuggestionProperties } from "../../datatypes/ArticleSuggestions";
import CountryUtil from "shared/src/uidispatcherapi/CountryUtil";

function Autosuggestion(props: {
    suggestion: string;
    value: string;
    icon: string;
    properties: ArticleSuggestionProperties | undefined | null;
    isRecentSearch: boolean | undefined | null;
}) {
    const value = props.value;
    const suggestion = props.suggestion;
    const icon = props.icon;
    const properties = props.properties;
    const highlighting = computeHighlighting(value, suggestion, true);
    let typeText: React.ReactNode = "";
    if (properties && properties.isBrand && !CountryUtil.getOptionalConfig()?.separateSuggestionTypes) {
        typeText = (
            <b>
                <FormattedMessage id={"EX_SUGGESTION_TYPE_BRAND"} />
            </b>
        );
    } else if (
        properties &&
        properties.isCategory &&
        properties.categoryId !== null &&
        !CountryUtil.getOptionalConfig()?.separateSuggestionTypes
    ) {
        typeText = (
            <b>
                <FormattedMessage id={"EX_SUGGESTION_TYPE_CATEGORY"} />
            </b>
        );
    } else if (properties && properties.contentUrl !== null) {
        typeText = (
            <b>
                <FormattedMessage id={"EX_SUGGESTION_TYPE_CONTENT"} />
            </b>
        );
    }
    return (
        <div className={"list-item-autosuggestion"}>
            {icon ? (
                <div className={"list-item-autosuggestion-icon"}>
                    <i className={icon} />{" "}
                </div>
            ) : null}
            <div className={"list-item-autosuggestion-text"}>
                {props.isRecentSearch && !value ? suggestion : formatHighlighting(highlighting)}
            </div>
            {<div className={"suggestion-type"}>{typeText}</div>}
            {props.isRecentSearch && value ? (
                <div className={"suggestion-type"}>
                    {
                        <b>
                            <FormattedMessage id={"EX_SUGGESTION_TYPE_RECENT_SEARCH"} />
                        </b>
                    }
                </div>
            ) : null}
        </div>
    );
}
export default Autosuggestion;
